module.exports = __webpack_public_path__ + "static/img/2501_phase_function_Paper_PointsHejduk_Prediction.c65d7e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2501_phase_function_Paper_PointsHejduk_Prediction.png
// module id = r1dZ
// module chunks = 0